// import React from "react";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./home.css";
import LandingPageIMG from "../../assets/Images/landing-image1d.jpg";
import LandingPageIMG2 from "../../assets/Images/landing-image2c.jpg";
import Artists from "./artists";

export default function Home() {
  const [titleVisible, setTitleVisible] = useState(false);
  const [paragraphVisible, setParagraphVisible] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);

  useEffect(() => {
    // Delay each animation using setTimeout, similar to jQuery delay
    const titleTimer = setTimeout(() => setTitleVisible(true), 1000); // 1s delay
    const paragraphTimer = setTimeout(() => setParagraphVisible(true), 700); // 0.7s delay
    const buttonTimer = setTimeout(() => setButtonVisible(true), 400); // 0.4s delay

    return () => {
      clearTimeout(titleTimer);
      clearTimeout(paragraphTimer);
      clearTimeout(buttonTimer);
    };
  }, []);

  return (
    <>
      <section className="landing-page">
        <div className="landing-heading">
          <h1
            id="landing-title"
            className={`fade-in ${titleVisible ? "visible" : ""}`}
          >
            BLACK JADE TATTOO
          </h1>
          <p
            id="landing-p"
            className={`slide-up ${paragraphVisible ? "visible" : ""}`}
          >
            Offering many creative styles that is unique to each artist creating
            custom tattoos tailored to the individual
          </p>
          <NavLink to="/booking" id="landing-button">
            <button
              className={`landing-btn btn-dark slide-up ${
                buttonVisible ? "visible" : ""
              }`}
              type="button"
            >
              BOOK WITH US NOW
            </button>
          </NavLink>
        </div>
      </section>
      {/* <!-- About summary  --> */}
      <section className="landing-page_summary">
        <div className="row no-gutters">
          <div className="column col-lg-6" id="mobile-bg">
            <div className="column-info">
              <h3>Who We Are.</h3>
              <p>
                Black Jade Tattoo was created in 2020 housing highly skilled
                artists providing a diverse range of style that the modern
                tattoo world has to offer. We offer many creative styles that is
                unique to each artist creating custom tattoos tailored to the
                individual...
              </p>
            </div>
            <NavLink to="/about">
              <button type="button" name="button" className="btn-view-more">
                VIEW MORE<i className="fas fa-chevron-circle-right"></i>
              </button>
            </NavLink>
          </div>
          <div
            className="col-lg-6"
            style={{ backgroundImage: `url(${LandingPageIMG})` }}
          >
            {/* <img src={LandingPageIMG} className="column-bg" alt="" /> */}
          </div>
        </div>
      </section>
      {/* <!-- Service summary  --> */}
      <section className="landing-page_summary">
        <div className="row no-gutters">
          <div
            className="col-lg-6"
            style={{ backgroundImage: `url(${LandingPageIMG2})` }}
          >
            {/* <img src={LandingPageIMG2} className="column-bg" alt="" /> */}
          </div>
          <div className="column col-lg-6" id="mobile-bg2">
            <div className="column-info">
              <h3>Professionals At Work.</h3>
              <p>
                Black Jade takes pride in our experience and professionalism
                when it comes to customer service. Styles we tattoo include (but
                not limited to): Oriental, Traditional Japanese, Black and Grey,
                Colour work, Realism, Traditional, Neo-traditional, Fine Line...
              </p>
            </div>
            <a href="/service">
              <button type="button" name="button" className="btn-view-more">
                VIEW MORE<i className="fas fa-chevron-circle-right"></i>
              </button>
            </a>
          </div>
        </div>
      </section>
      {/* Artists section */}
      <section className="artist-section">
        <h3 className="landing-artist-title">Meet Our Artists.</h3>
        <div className="card-deck" style={{ justifyContent: "center" }}>
          <div className="row">
            <Artists />
          </div>
        </div>
        <a href="/artists" style={{ color: "inherit", textDecoration: "none" }}>
          <button type="button" name="button" className="btn-view-more">
            VIEW MORE ARTISTS<i className="fas fa-chevron-circle-right"></i>
          </button>
        </a>
      </section>
      {/* <!-- Location/Booking/Contact summary --> */}
      <section className="">
        <div className="row no-gutters">
          <div className="column col-lg-6 col-md-12 col-sm-12">
            <div className="map-panel">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13244.303456373143!2d151.0341269!3d-33.913447!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4cb8e8a429ff077c!2sBlack%20Jade%20Tattoo!5e0!3m2!1sen!2sau!4v1613820534818!5m2!1sen!2sau"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="map"
              ></iframe>
            </div>
          </div>
          <div
            className="column col-lg-3 col-md-6 col-sm-6"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="column-info column-location">
              <a href="https://goo.gl/maps/NV4XE7fn7zoiot568" target="_blank">
                <i className="fas fa-map-marked-alt lbc-icon"></i>
                <p>
                  {" "}
                  Little Saigon Plaza, Level 1 <br />
                  Shop 13/462 Chapel Rd, Bankstown NSW 2200
                </p>
              </a>

              <i className="far fa-clock lbc-icon"></i>
              <p>Open Everyday: 10AM - 6PM</p>

              <a href="tel:0297962994">
                <i className="fas fa-mobile-alt lbc-icon"></i>
                <p>(02) 9796 2994</p>
              </a>

              <a href="mailto:blackjadetattoo@hotmail.com">
                <i className="far fa-envelope lbc-icon"></i>
                <p>blackjadetattoo@hotmail.com</p>
              </a>
            </div>
          </div>
          <div className="column col-lg-3 col-md-6 col-sm-6">
            <div className=" LBC-right">
              <div className="lbc-btn-position">
                <NavLink to="/booking">
                  <button className="lbc-btn btn-dark" type="button">
                    BOOKING
                  </button>
                </NavLink>
                <NavLink to="/contact">
                  {" "}
                  <button className="lbc-btn btn-dark" type="button">
                    CONTACT
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
